module.exports = __webpack_public_path__ + "static/orange2-6de73f8af7a25b437c1f32702e571469.svg";